import { useEffect, useRef } from 'react';
export const useOnceInView = (eventCall, options) => {
    const ref = useRef(null);
    const hasFired = useRef(false);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !hasFired.current) {
                eventCall();
                hasFired.current = true;
                observer.disconnect();
            }
        }, { threshold: options?.threshold ?? 0.5 });
        observer.observe(el);
        return () => observer.disconnect();
    }, [eventCall, options?.threshold]);
    return ref;
};
